// C:\Users\Luca_\OneDrive\Desktop\versus-arena-mvp\frontend\src\utils\gameSlugs.js
// src/utils/gameSlugs.js
import { gamesList } from './games';

export function normalizeSlug(s = '') {
  return String(s)
    .toLowerCase()
    .trim()
    .replace(/[\s_]+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-');
}

const CANONICAL = {
  'ea fc': 'ea-fc',
  'ea-sports-fc': 'ea-fc',
  eafc: 'ea-fc',
  'call-of-duty': 'cod',
  cod: 'cod',
  'clash-royale': 'clash-royale',
  csgo: 'cs-go',
  'cs-go': 'cs-go',
  'cs:go': 'cs-go',
  'mario-kart': 'mario-kart',
  'mario-kart-world': 'mario-kart',
  valorant: 'valorant',
};

export function slugFromGameKey(key = '') {
  const norm = normalizeSlug(key);
  return CANONICAL[norm] || norm;
}

export function canonicalGameKey(nameOrKey = '') {
  const norm = normalizeSlug(nameOrKey);
  return CANONICAL[norm] || norm;
}

export function getGameBySlug(slug = '') {
  const wanted = canonicalGameKey(slug);
  const list = Array.isArray(gamesList) ? gamesList : [];
  for (const g of list) {
    const candidateKey = canonicalGameKey(g.key || g.name || '');
    if (candidateKey === wanted) return g;
  }
  return null;
}
